import { Link, NavLink } from "react-router-dom";
import { Plus, ShoppingBag, ShoppingCart } from "react-feather";
import { authCustomerData } from "../../admin/components/GetAuth";
import { hasFeature } from "../../admin/components/Features";
import { openCartDrawer, useCartCount } from "../../frontend/pages/shop/shopApi";
import CartDrawer from "../../frontend/pages/shop/components/CartDrawer";
import styles from "./header.module.css";

const initials = (name) => {
  const words = (name || "").trim().split(/\s+/).filter(Boolean);
  if (!words.length) return "";
  return (words[0][0] + (words.length > 1 ? words[words.length - 1][0] : "")).toUpperCase();
};

// Customer panel header, coloured with the company's theme (--primary-color / --secondary-color)
function Header({ companyName = "Company", logo = "/images/logo2.svg" }) {
  const customer = authCustomerData();
  const shopOn = hasFeature("shop");
  const cartCount = useCartCount(shopOn);

  return (<header className={styles.Header}>
    <div className={styles.Container}>
      <div className={styles.HeadRow}>
        <Link to="/customer/my-bookings" className={styles.Brand} aria-label={companyName}>
          <span className={styles.LogoWrap}>
            <img src={logo} alt={companyName} className={styles.HeadLogo} />
          </span>
          <span className={styles.BrandText}>
            <span className={styles.BrandName}>{companyName}</span>
            <span className={styles.BrandSub}>Customer portal</span>
          </span>
        </Link>

        <div className={styles.HeadActions}>
          {shopOn && (<NavLink to="/customer/shop" className={styles.ShopBtn}>
            <ShoppingBag size={16} />
            <span>Shop Now</span>
          </NavLink>)}

          {shopOn && (<NavLink to="/customer/shop/cart" onClick={(e) => { e.preventDefault(); openCartDrawer(); }} className={styles.CartBtn} aria-label={`Cart, ${cartCount} items`} title="Cart">
            <ShoppingCart size={18} />
            {cartCount > 0 && <span className={styles.CartCount}>{cartCount > 99 ? "99+" : cartCount}</span>}
          </NavLink>)}

          <NavLink to="/customer/add-booking" className={styles.BookBtn}>
            <Plus size={16} />
            <span>New booking</span>
          </NavLink>

          {customer?.name && (
            <Link to="/customer/profile" className={styles.UserChip} title="My profile">
              <span className={styles.Avatar}>{initials(customer.name)}</span>
              <span className={styles.UserName}>{customer.name}</span>
            </Link>
          )}
        </div>
      </div>
    </div>
    {/* The one slide-in cart for every customer page */}
    {shopOn && <CartDrawer shopPath="/customer/shop" cartPath="/customer/shop/cart" />}
  </header>);
}

export default Header;
